import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocaleService
{
  private localeSubject: BehaviorSubject<string>;

  constructor()
  {
    const locale = localStorage.getItem('locale') || 'hn';
    this.localeSubject = new BehaviorSubject<string>(locale);
  }

  setLocale(newLocale: string)
  {
    localStorage.setItem('locale', newLocale);
    this.localeSubject.next(newLocale);
  }

  getLocale(): Observable<string>
  {
    return this.localeSubject.asObservable();
  }
}
